import script from "./TypeAMuseumPremialita.vue?vue&type=script&setup=true&lang=ts"
export * from "./TypeAMuseumPremialita.vue?vue&type=script&setup=true&lang=ts"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./TypeAMuseumPremialita.vue?vue&type=style&index=1&id=3bdee6d6&lang=css"

const __exports__ = script;

export default __exports__